// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"91f6ee97","2682":"438f7144","5649":"ba3bd4f5","6134":"19147c62","6144":"438f7144","8981":"0fb485e2","9407":"85b472c3"}[chunkId] + ".chunk.css";
};